import { CheckOutlined } from "@ant-design/icons";
import {
  Col,
  MenuProps,
  message,
  notification,
  TreeSelect,
  Upload
} from "antd";
import { isEmpty, join, map, rangeRight } from "lodash";
import Moment from "moment";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import configUrl from "./config";
import ExcelJS from "exceljs";

const { TreeNode } = TreeSelect;

export const listTrangThai = [
  { value: 1, label: "Đang soạn thảo" },
  { value: 2, label: "Chờ xuất bản" },
  { value: 3, label: "Xuất bản" },
  { value: 4, label: "Hủy Xuất bản (Cho sửa và gửi lại XB)" }
];

/**
 * setCookieValue: Gán cookie
 * @param {string} name
 * @param {string} value
 */
export const setCookieValue = (name: string, params: string, opt = {}) => {
  return cookie.save(name, params, opt);
};

/**
 * getCookieValue: Lấy cookie
 * @param {string} name
 */
export const getCookieValue = (name: any) => {
  return cookie.load(name);
};

/**
 * removeCookieValue: Xoá cookie value
 * @param {string} name
 * @returns
 */
export const removeCookieValue = (name: string) =>
  cookie.remove(name, { path: "/" });

/**
 * setLocalStorage: Lưu dữ liệu vào localStorage
 * @param {string} key
 * @param {string} value
 */
export const setLocalStorage = (key: string, value: any) =>
  localStorage.setItem(key, JSON.stringify(value));

/**
 * getLocalStorage: Lấy dữ liệu từ localStorage
 * @param {string} key
 */
export const getLocalStorage = (key: string): any => {
  try {
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  } catch (error) {
    return null;
  }
};

/**
 * removeLocalStorage: Xoá dữ liệu từ localStorage theo key
 * @param {string} key
 */
export const removeLocalStorage = (key: any) => localStorage.removeItem(key);

/**
 * Tạo mảng năm dựa theo số đầu vào
 * Năm sẽ dựa từ năm hiện tại trừ đi
 * @param {int} number
 */
export const yearArrByRange = (number: number) => {
  const currentYear = new Date().getFullYear();
  return rangeRight(currentYear + 1, currentYear - number);
};

/**
 * removeAllLocalStorage: Xoá hết dữ liệu trong localStorage
 * @returns
 */
export const removeAllLocalStorage = () => localStorage.clear();

/**
 * logOut: Đăng xuất
 */
export const logOut = async () => {
  await removeCookieValue("accessTokenTVDTBDT");
  await removeAllLocalStorage();

  const accessTokenTVDTBDT = getCookieValue("accessTokenTVDTBDT");
  if (!accessTokenTVDTBDT) {
    window.location.href = `${await configUrl.API_URL}/saml/logout?url=${
      window.location.protocol
    }//${window.location.host}${window.location.hash}`;
  }
};

/**
 * reDataForTable: Dùng cho phân trang
 * @param {object} data
 * @param {int} activePage
 * @param {int} pageSize
 */
export const reDataForTable = (data: any, activePage = 1, pageSize = 5000) =>
  map(data, (item, index) => ({
    key: activePage === 1 ? index + 1 : index + (activePage - 1) * pageSize + 1,
    ...item
  }));

/**
 * Get the datetime by format
 * @param {date} obj.value the datetime value
 * @param {string} obj.format the format which will be used to convert the value
 * @param {boolean} obj.isUTC if true, the value will be converted to UTC time (default use local time)
 * @param {boolean} obj.isString if true, the value will be returned as a string
 * @returns {moment} the moment instance
 * @memberof Helpers
 */
export const getDateTime = ({
  value = undefined,
  format = null,
  isUTC = false,
  isString = true
}: {
  value?: any;
  format?: string | null;
  isUTC?: boolean;
  isString?: boolean;
}): any => {
  if (!value || !Moment(value).isValid()) {
    return undefined;
  }
  const newValue = isUTC ? Moment.utc(value) : Moment.utc(value).local();
  let result: any = newValue;
  if (isString && !format) {
    result = Moment(newValue).format();
  }
  if (isString && format) {
    result = Moment(newValue).format(format);
  }
  if (!isString && !format) {
    result = Moment(Moment(newValue).format());
  }
  if (!isString && format) {
    result = Moment(Moment(newValue).format(format), format);
  }
  return result;
};

/**
 * checkQuyenLogin: kiểm tra user đăng nhập theo vai trò truyền vào
 * @param {Array} listQuyen
 * @param {string} maQuyen
 */
export const checkQuyenLogin = (
  isAdmin: boolean,
  listQuyen: any,
  maQuyen: string
) => {
  const result = listQuyen.find((item: any) => item.tenQuyen === maQuyen);
  if (result || isAdmin) {
    return true;
  }
  return false;
};

export const checkVaiTroUserLogin = (data: any, vaiTro: string) => {
  const vaiTros = data?.user?.vaiTros ?? [];
  const result = vaiTros.find(
    (value: { maVaiTro: string }) => value.maVaiTro === vaiTro
  );
  if (result) {
    return true;
  }
  return false;
};

export interface CustomMenuItem {
  id?: number;
  key: any;
  icon?: React.ReactNode;
  label: React.ReactNode;
  hienthi?: boolean;
  children?: CustomMenuItem[];
  type?: "group";
}

/**
 * checkQuyenMenu: kiểm tra quyền hiển thị menu
 * @param {Array} permissions
 * @param {Array} listQuyen
 * @param {boolean} isAdmin
 */

export const checkQuyenMenu = (
  permissions: string[],
  listQuyen: string[],
  isAdmin: boolean
): boolean => {
  const tenQuyenArray = listQuyen.map((quyen: any) => quyen.tenQuyen);
  if (isAdmin) {
    return true;
  } else {
    for (let i = 0; i < permissions.length; i++) {
      if (tenQuyenArray.includes(permissions[i])) {
        return true;
      }
    }
  }
  return false;
};

export const checkVaiTroMenu = (
  permissions: string[],
  listVaiTro: string[],
  isAdmin: boolean
): boolean => {
  const maVaiTro = listVaiTro.map((quyen: any) => quyen.maVaiTro);
  if (isAdmin) {
    return true;
  } else {
    for (let i = 0; i < permissions.length; i++) {
      if (maVaiTro.includes(permissions[i])) {
        return true;
      }
    }
  }
  return false;
};

export const createMenuItems = (
  items: CustomMenuItem[]
): MenuProps["items"] => {
  return items
    ? (items
        .filter((item) => item.hienthi)
        .map(({ hienthi, ...item }) => ({
          ...item,
          children: item.children ? createMenuItems(item.children) : undefined
        })) as MenuProps["items"])
    : [];
};

/**
 * formatNumber: format số
 * @param {int} value
 */
export const formatNumber = (value: any) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  const valueTmp = value ? value.toString().replace(".", ",") : 0;
  return valueTmp.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
};

/**
 * beforeUploadIMG: Check file trước khi tải lên
 * @param {object} file
 */
export const beforeUploadIMG = (file: { size: number }) => {
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Ảnh phải nhỏ hơn 2MB!");
  }
  return isLt2M;
};

/**
 * StringValueReturn : Hàm xử lý dữ liệu trên bảng (Row expand)
 * @param {string} values
 */
export function StringValueReturn(values: any) {
  const { size, type, value, text, fieldName } = values;
  let valueTmp;
  if (type === "text") {
    valueTmp = value || "";
  } else if (type === "date") {
    valueTmp = "";
    if (value) {
      valueTmp = Moment(value).format("DD/MM/YYYY");
    } else if (value !== 0) {
      valueTmp = Moment(value).format("DD/MM/YYYY");
    } else {
      valueTmp = "";
    }
  } else if (type === "object") {
    valueTmp = value ? value[fieldName] : "";
  } else if (type === "file") {
    valueTmp = value ? (
      <Link to={`/custom-views/view-pdf?pdfUrl=${value}`}>Xem nội dung</Link>
    ) : (
      ""
    );
  } else if (type === "html") {
    valueTmp = value ? (
      <Link to={`/custom-views/view-html?htmlValue=${value}`}>
        Xem nội dung
      </Link>
    ) : (
      ""
    );
  } else if (type === "boolean") {
    valueTmp = value ? "Có" : "Không";
  } else if (type === "gender") {
    valueTmp = value ? "Nam" : "Nữ";
  } else if (type === "currency") {
    valueTmp = value ? formatNumber(value) : 0;
  } else if (type === "VND") {
    valueTmp = value ? `${formatNumber(value)} (Đồng)` : 0;
  } else if (type === "TrieuVND") {
    valueTmp = value ? `${formatNumber(value)} (Triệu đồng)` : 0;
  } else if (type === "TyVND") {
    valueTmp = value ? `${formatNumber(value)} (Tỷ đồng)` : 0;
  } else if (type === "HA") {
    valueTmp = value ? `${formatNumber(value)} (Hecta)` : 0;
  } else if (type === "Tan") {
    valueTmp = value ? `${formatNumber(value)} (Tấn/năm)` : 0;
  } else if (type === "km") {
    valueTmp = value ? `${value} (km)` : 0;
  } else if (type === "kV") {
    valueTmp = value ? `${value} (kV)` : 0;
  } else if (type === "MW") {
    valueTmp = value ? `${value} (MW)` : 0;
  } else if (type === "MVA") {
    valueTmp = value ? `${value} (MVA)` : 0;
  } else if (type === "m2") {
    valueTmp = value ? `${value} (m2)` : 0;
  } else if (type === "array") {
    const newArr = map(value, (value) => value[fieldName]);
    valueTmp = join(newArr, ", ");
  }
  if (!isEmpty(valueTmp) || valueTmp || valueTmp === 0) {
    return (
      <Col md={size} span={8} style={{ paddingBottom: 8 }} xs={24}>
        {text}: {valueTmp}
      </Col>
    );
  }
  return null;
}

/**
 * addAllValue : hàm get all value ( ví dụ : xã phường )
 * @param {array} array
 * @param {string} [type='diaPhuong']
 */
export const addAllValue = (array: any, type = "diaPhuong", object: any) => {
  if (type === "diaPhuong") {
    return [{ id: 0, ma: "", ten: "---Tất cả---" }, ...array];
  }
  if (type === "custom") {
    return [object, ...array];
  }
  return undefined;
};
interface TreeNode {
  id: number;
  donVi?: string;
  value: number;
  key: string;
  title: JSX.Element;
  disabled?: boolean;
  children?: TreeNode[];
}

export const convertDataToTree = (data: any): TreeNode[] => {
  const rs: TreeNode[] = data.map((item: any) => {
    const {
      id,
      ten_don_vi,
      ten_phong_ban,
      donVi,
      ds_phong_ban,
      ds_nguoi_xu_ly
    } = item;
    const obj: TreeNode = {
      id,
      donVi,
      value: id,
      key: `${id}-${ten_don_vi || ten_phong_ban}`,
      title: <span>{ten_don_vi || ten_phong_ban}</span>
    };
    const listNguoiDung = !isEmpty(ds_nguoi_xu_ly)
      ? converListUserInTreeSelect(ds_nguoi_xu_ly, id)
      : [];
    const children = [
      ...(ds_phong_ban ? convertDataToTree(ds_phong_ban) : []),
      ...listNguoiDung
    ];
    return {
      ...obj,
      children: children.length > 0 ? children : undefined
    };
  });
  return rs;
};

export const converListUserInTreeSelect = (
  data: any[],
  pId: number
): TreeNode[] => {
  const dataNguoiXuLy: TreeNode[] = !isEmpty(data)
    ? data.map((nguoi: any) => {
        const { id, ten_nguoi_dung, user_name } = nguoi;
        return {
          id,
          value: id,
          title: ten_nguoi_dung,
          user_name,
          pId,
          key: `${id}-${user_name}`,
          isLeaf: true
        };
      })
    : [];
  return dataNguoiXuLy;
};

/**
 * renderDataDSNguoiDung: lấy danh sách người xử lý
 * @param {array} listNguoiDung
 */
export const renderDataDSNguoiDung = (listNguoiDung: any) => {
  const listUser = listNguoiDung.map((item: any) => {
    if (item.children) {
      return renderDataDSNguoiDung(item.children);
    }
    return { ...item };
  });
  return listUser;
};

/**
 * isCheckExcel : hiển thị check xuất excel
 */
export const isCheckTable = (check: boolean) =>
  check === true ? <CheckOutlined style={{ color: "#0e5ace" }} /> : null;

export const checkAuth = (roles: string[], listVaiTroUser: string[]) => {
  const isAdmin = listVaiTroUser.includes("ADMIN");
  const isActive = listVaiTroUser.some((value) => roles.includes(value));
  const status = { isAdmin, isActive, isXem: isActive, listVaiTroUser };
  return status;
};

/**
 * getFileName: get tên file
 * @param {Object} value
 */
export const getFileName = (value: any) =>
  value.split("/").pop().split("#")[0].split("?")[0];

/**
 * boDauTiengViet: Chuyển văn bản có dấu sang không dấu
 * @param {string} str
 * @returns Văn bản không dấu
 */
export const boDauTiengViet = (tempStr: any) => {
  let str = tempStr;
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  return str;
};

/**
 * beforeUploadLimit: Check file trước khi tải lên ko quá size MB
 * @param {number} limitSize
 * @param {object} file
 */
export const beforeUploadLimit = (
  limitSize: number,
  file: { name: any; size: number }
) => {
  const isName = boDauTiengViet(file.name);
  // const isFileTrue = file.size / 1024 / 1024 < limitSize;
  // if (!isFileTrue) {
  //   message.error(`Dung lượng tải lên phải nhỏ hơn ${limitSize}MB!`);
  // }
  if (file.size === 0) {
    message.error(
      `File tải lên không có nội dung. Vui lòng kiểm tra lại nội dung file!`
    );
    return Upload.LIST_IGNORE;
  }
  return isName || Upload.LIST_IGNORE;
};

type User = {
  title: string;
  key: string;
  id: number;
  isLeaf: boolean;
};

type TreeNodes = {
  title: string;
  key: string;
  id: number;
  donVi: boolean;
  children?: TreeNode[];
  ds_nguoi_xu_ly: User[];
};

export const convertNodeToTrees = (node: any): TreeNodes => {
  const tree: TreeNodes = {
    title: node.ten_don_vi || node.ten_phong_ban,
    key: `${node.id}`,
    id: node.id,
    donVi: node.donVi,
    ds_nguoi_xu_ly: node.ds_nguoi_xu_ly
      ? node.ds_nguoi_xu_ly.map((user: any) => ({
          title: user.ten_nguoi_dung,
          key: `${user.id}-${user.user_name}`,
          id: user.id,
          isLeaf: true
        }))
      : []
  };

  if (node.ds_phong_ban && node.ds_phong_ban.length > 0) {
    tree.children = node.ds_phong_ban.map((childNode: any) =>
      convertNodeToTrees(childNode)
    );
  }

  return tree;
};

export const convertDataToTrees = (data: any[]): TreeNodes[] => {
  return data.map((item: any) => convertNodeToTrees(item));
};

/**
 * Trả về ngày tháng long - date 'DD/MM/YYYY'
 * @param {date} value
 */
export const longToDate = (value: any) => {
  if (value === 0) {
    return "";
  }
  if (value === null) {
    return "";
  }
  if (value === undefined) {
    return "";
  }
  return Moment(value).format("DD/MM/YYYY");
};

/**
 * renderTrangThaiDT: hiển thị tiêu đề nút chuyển xử lý
 * @param {int} TT
 */
export const renderTrangThai = (TT: number) => {
  let trangThai = "";
  switch (TT) {
    case 1:
      trangThai = "Đang soạn thảo";
      break;
    case 2:
      trangThai = "Chờ xuất bản";
      break;
    case 3:
      trangThai = "Xuất bản";
      break;
    case 4:
      trangThai = "Hủy xuất bản";
      break;
    default:
  }
  return trangThai;
};

export const exportToExcel = async (dataTable: any, namefile: string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Thống kê người đăng");

  // Kiểm tra xem dataTable có dữ liệu không
  if (!dataTable || dataTable.length === 0) {
    notification.error({
      message: "Thông báo",
      duration: 4,
      description: "Không có dữ liệu."
    });
    return; // Thoát hàm nếu không có dữ liệu
  }

  // Thêm hàng tiêu đề
  const titleRow = worksheet.addRow(["Danh sách thống kê người đăng"]);
  titleRow.font = { bold: true, size: 14 }; // Định dạng chữ đậm và cỡ chữ
  titleRow.alignment = { horizontal: "center" }; // Căn giữa hàng tiêu đề
  // Merge các ô của hàng tiêu đề
  const lengthNhomSoLuong = dataTable?.[0]?.nhomSoLuong?.length || 0;
  const lastColumn = 2 + lengthNhomSoLuong; // Số cột bao gồm STT, Tên người đăng và các nhóm tư liệu
  worksheet.mergeCells(`A1:${String.fromCharCode(64 + lastColumn)}1`);

  // Thiết lập tiêu đề cột
  const headerRow = [
    "STT",
    "Tên người đăng",
    ...dataTable[0].nhomSoLuong.map((item: any) => item.tenNhomTuLieu)
  ];
  const header = worksheet.addRow(headerRow);

  // Định dạng tiêu đề cột
  header.eachCell((cell: any) => {
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" }
    };
    cell.font = { bold: true }; // Định dạng in đậm cho tiêu đề
    cell.alignment = { horizontal: "center" }; // Căn giữa tiêu đề
  });

  // Thêm dữ liệu vào worksheet
  dataTable.forEach((item: any, index: number) => {
    const row = [
      index + 1,
      item.tenNguoiDang,
      ...item.nhomSoLuong.map((nhom: any) => nhom.soLuong)
    ];
    const dataRowObj = worksheet.addRow(row);

    dataRowObj.getCell(1).alignment = { horizontal: "center" };

    // Định dạng viền cho hàng dữ liệu
    dataRowObj.eachCell((cell: any) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" }
      };
    });
  });

  // Thiết lập chiều rộng cột cho các cột
  const columnWidths = [10, 30, 15, 15, 20, 25, 10, 10, 20, 10]; // Ví dụ thiết lập chiều rộng: STT (5), Tên người đăng (20), các cột còn lại (15)

  // Cập nhật chiều rộng cho các cột
  worksheet.columns.forEach((column: any, index: number) => {
    column.width = columnWidths[index] || 10; // Nếu không có giá trị trong columnWidths, gán 10 làm chiều rộng mặc định
  });

  // Tạo file Excel
  const blob = await workbook.xlsx.writeBuffer();

  // Tạo một đối tượng blob để tải về
  const blobData = new Blob([blob], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blobData);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${namefile}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/**
 * handleExportExcelFuncNew : Hàm xử lý xuât excel dữ liệu trên bảng
 * @param {array} datatable
 * @param {string} docName
 */
export const handleExportExcelFuncNew = (datatable: any, docName: string) => {
  const dataTime = Moment(new Date()).format("DD_MM_YYYY_HH_ss");
  const styles = `<style>
      .rotate { mso-rotate: 90; white-space:nowrap }
      .rotate-90 { mso-rotate: -90; white-space:nowrap }
      table tr td {border: thin solid #000 !important; color: #393939 !important}
      table tr.noBorder td {border: 0 !important }
    </style>`;
  const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8" /><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->${styles}</head><body>${datatable}</body></html>`;
  const myBlob = new Blob([template], {
    type: "application/vnd.ms-excel;charset=utf-8,"
  });
  const url = window.URL.createObjectURL(myBlob);
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.href = url;
  a.download = `${docName}_${dataTime}.xls`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const errUploadFile = () => {
  notification.error({
    message: "Thông báo",
    duration: 4,
    description: "Tải file thất bại, vui lòng kiểm tra lại!"
  });
};

export const renderTuLieuHinhAnhVideo = (item: any) => {
  if (item.isHinhAnh) {
    return "Hình ảnh";
  } else if (item.isTuLieu) {
    return "Tư liệu";
  } else if (item.isVideo) {
    return "Video";
  }

  return "";
};